module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[108]229.072ccdf.woff2";